import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import api from '../../services/api';
import { getScheduleRequest, hasScheduleRequest } from '../../utils/scheduleUtils';
import { getPostLoginHomePath } from '../../utils/canManageSubLogins';

const AuthCallback: React.FC = () => {
  const history = useHistory();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) {
      return;
    }

    const params = new URLSearchParams(window.location.search);

    if (!window.location.search) {
      return;
    }

    processed.current = true;

    const token = params.get('token');
    const access_token = params.get('access_token');
    const error = params.get('error');
    const error_description = params.get('error_description');
    const needsPhone = params.get('needs_phone');
    const userId = params.get('user_id');
    const phone = params.get('phone');

    if (error) {
      alert(`Erro na autenticação: ${error_description || error}`);
      history.push('/login');
      return;
    }

    const finalToken = token || access_token;

    if (needsPhone === 'true' || needsPhone === '1' || params.has('needs_phone')) {
      try {
        if (finalToken) {
          localStorage.setItem('@7Cantos:tempToken', finalToken);
          api.defaults.headers.authorization = `Bearer ${finalToken}`;
        }

        if (userId) {
          localStorage.setItem('@7Cantos:tempUserId', userId.toString());
        }

        if (phone) {
          localStorage.setItem('@7Cantos:tempPhone', phone);
        }

        const stateData = {
          requiresPhoneCompletion: true,
          user_id: userId,
          type: 'tenant',
          phone: phone,
          token: finalToken
        };

        history.push({
          pathname: '/complete-registration',
          state: stateData
        });
      } catch (err) {
        history.push('/login');
      }
      return;
    }

    if (finalToken) {
      try {
        localStorage.setItem('@7Cantos:token', finalToken);

        if (phone) {
          localStorage.setItem('@7Cantos:tempPhone', phone);
        }

        api.defaults.headers.authorization = `Bearer ${finalToken}`;

        api.post('/api/auth/me')
          .then((response) => {
            const userData = response.data.data || response.data;

            if (!userData || !userData.id) {
              history.push('/login');
              return;
            }

            localStorage.setItem('@7Cantos:user', JSON.stringify(userData));

            const actualDate = new Date(Date.now());
            const dateToExpires = new Date(actualDate.getTime() + 24 * 60 * 60 * 1000);
            localStorage.setItem('@7Cantos:dateToExpires', dateToExpires.toString());

            if (hasScheduleRequest()) {
              const scheduleRequest = getScheduleRequest();
              if (scheduleRequest?.propertyId) {
                window.location.href = `/schedule/${scheduleRequest.propertyId}`;
                return;
              }
            }

            window.location.href = getPostLoginHomePath(userData);
          })
          .catch((err) => {
            history.push('/login');
          });
      } catch (err) {
        history.push('/login');
      }
      return;
    }
    else {
      history.push('/login');
    }
  }, [history]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '16px', marginBottom: '10px' }}>
          Processando autenticação...
        </p>
        <p style={{ fontSize: '12px', color: '#999', marginTop: '20px' }}>
          Aguarde um momento
        </p>
        <div style={{
          marginTop: '20px',
          width: '30px',
          height: '30px',
          border: '3px solid #f3f3f3',
          borderTop: '3px solid #dd6435',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default AuthCallback;